import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';

export const hourOfDay = {
	MORNING: 'morning',
	AFTERNOON: 'afternoon',
	EVENING: 'evening',
} as const;
export type HourOfDay = (typeof hourOfDay)[keyof typeof hourOfDay];

const getTimeOfDayBucket = (): HourOfDay => {
	const currentHour = DateTime.now().hour;
	if (currentHour > 6 && currentHour <= 12) {
		return hourOfDay.MORNING;
	}
	if (currentHour > 12 && currentHour <= 17) {
		return hourOfDay.AFTERNOON;
	}

	return hourOfDay.EVENING;
};

const RESYNC_INTERVAL_MS = 60_000;

// The server and the browser can be in different timezones, so computing this on first
// render would render a different value during SSR than during client hydration (React
// error #418). Default to a fixed value on both, then correct it after mount. Resync on an
// interval (not just once) so a session left open across a bucket boundary (e.g. noon) still
// updates the greeting, matching the pre-fix behavior of recomputing on every render.
export function useTimeOfDay(): HourOfDay {
	const [timeOfDay, setTimeOfDay] = useState<HourOfDay>(hourOfDay.MORNING);

	useEffect(() => {
		const sync = () => setTimeOfDay(getTimeOfDayBucket());
		sync();
		const intervalId = setInterval(sync, RESYNC_INTERVAL_MS);
		return () => clearInterval(intervalId);
	}, []);

	return timeOfDay;
}
